export const STORES = [
  { label: "US", id: 1, name: "United States", currency: "$" },
  { label: "UK", id: 2, name: "United Kingdom", currency: "£" },
  { label: "EU", id: 3, name: "International", currency: "€" },
  { label: "DE", id: 4, name: "Germany", currency: "€" },
  { label: "UAT", id: 5, name: "UAT (sandbox)", currency: "$" },
];

export const currencyForId = (id) =>
  STORES.find((s) => s.id === Number(id))?.currency || "$";

export const STORE_LABELS = STORES.map((s) => s.label);

export const labelForId = (id) =>
  STORES.find((s) => s.id === Number(id))?.label || String(id ?? "");

export const idForLabel = (label) =>
  STORES.find((s) => s.label === label)?.id || null;

export { DEFAULT_STORE_LABEL as DEFAULT_STORE } from "../common/storeDefaults";
